/* eslint-disable @typescript-eslint/no-explicit-any */
import { IFunctionMapping, IFunctionOptions } from '../interfaces';
import { FunctionGatewayFactory } from './functionGatewayFactory.service';

export default class FunctionGatewayService {
    /**
     * Invokes a function with the specified parameters and options.
     *
     * @param functionName - The name of the function to invoke.
     * @param params - This parameters is passed to the functionMapping config.
     * @param functionMapping - An object that maps function names to function implementations. This object should conform to the `IFunctionMapping` interface.
     * @param options - An object containing additional options for invoking the function. This may include settings such as the mappingType ('lambda' or 'rest').
     *
     * @returns - Returns a promise that resolves with the result of the invoked function or rejects with an error if the invocation fails.
     */
    static invoke(
        functionName: string,
        params: unknown,
        functionMapping: IFunctionMapping,
        options: IFunctionOptions = {},
    ): Promise<any> {
        const service = FunctionGatewayFactory.gateway(
            functionName,
            params,
            functionMapping,
            options,
        );
        return service.invoke(functionName, params, functionMapping);
    }
}
